module.exports = __webpack_public_path__ + "img/Frame_6.96548c25.png";